import { all, call } from 'redux-saga/effects';
import ext_app from './domains/extension/app/saga';
import global from './domains/global/saga'
import query from './domains/query/saga';
import explorer from './domains/explorer/saga';

const sagas = [
    call(ext_app),
    call(global),
    call(query),
    call(explorer),
]

export default function* rootSaga() {
    yield all(sagas);
}
